import { useEffect, useState } from 'react';
import { onSnapshot, orderBy, query } from 'firebase/firestore';
import { Agency } from '../../entities';
import { getAgencyCollection } from '../../infrastructures/firebase';

export const useAgencies = (): {
  isFetching: boolean;
  agencies: Agency[];
} => {
  const [isFetching, setIsFetching] = useState(true);
  const [agencies, setAgencies] = useState<Agency[]>([]);

  useEffect(() => {
    const q = query(getAgencyCollection, orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data());

        if (data) {
          setAgencies(data);
        }

        setIsFetching(false);
      },
      (error) => {
        console.error('catch useAgencies error: ', error.message);
        setIsFetching(false);
      },
    );

    return unsubscribe;
  }, []);

  return { isFetching, agencies };
};
